/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {EventEmitter, Injectable} from '@angular/core';
import {PathAlertsComponent} from '../component/path-alerts.component';

@Injectable({
    providedIn: 'root'
})
export class PathAlertsService {
    public readonly openEvent = new EventEmitter<PathAlertsComponent>();
}
